/**
 * Italian translations
 */
import type { Translations } from "./en";

export const it: Translations = {
  errors: {
    roomNoEmail: "Questa sala non ha un indirizzo email configurato. Contatta il tuo amministratore.",
    roomAlreadyBooked: "Questa sala è già prenotata per questa fascia oraria. Prova un'altra sala.",
    bookingFailed: "Impossibile aggiungere la sala all'evento",
    networkError: "Controlla la tua connessione Internet e riprova. Se il problema persiste, prova a riconnetterti.",
    authError: "Effettua nuovamente l'accesso.",
    authRequired: "Autenticazione richiesta",
    authFailed: "Autenticazione fallita. Riprova.",
    accountNotFound: "Nessun account Deskare è associato all'email {email}. Contatta il tuo amministratore.",
    userCancelled: "L'accesso è stato annullato. Riprova quando sei pronto.",
    accountNotSupported: "Questo tipo di account non è supportato. Accedi con un account Microsoft 365 aziendale o scolastico.",
    popupBlocked: "La finestra di accesso è stata bloccata dal browser. Consenti i popup per questo add-in e riprova.",
    consentRequired: "È richiesto il consenso dell'amministratore. Chiedi al tuo amministratore di approvare questo add-in.",
    apiNotAvailable: "Il servizio identità Microsoft non è disponibile in questa versione di Outlook. Aggiorna Outlook e riprova.",
    validationError: "Verifica i tuoi dati e riprova.",
    unknownError: "Si è verificato un errore imprevisto.",
    outlookContextUnavailable: "Il contesto Office non è disponibile",
    outlookNoAppointment: "Nessun appuntamento attivo",
    outlookCannotUpdateLocation: "Impossibile aggiornare la posizione",
    outlookCannotAddAttendee: "Impossibile aggiungere il partecipante",
    outlookCannotStoreData: "Impossibile salvare i dati",
  },
  success: {
    roomAdded: "La sala è stata aggiunta al tuo evento.",
  },
  ui: {
    addRoom: "Aggiungi sala",
    addingRoom: "Aggiunta in corso...",
    addAnotherRoom: "Aggiungi un'altra sala",
    done: "Fatto",
    close: "Chiudi",
    viewOtherRooms: "Vedi altre sale",
    searchRooms: "Cerca sale",
    reconnect: "Riconnetti",
    roomFree: "Disponibile",
    roomBooked: "Prenotata",
    roomAddedTitle: "Sala aggiunta!",
    roomAddedDescription: "La sala è stata aggiunta al tuo evento e impostata come luogo.",
    loadingAppointment: "Caricamento dettagli appuntamento...",
    filters: "Filtri",
    minCapacity: "Capacità minima",
    equipment: "Attrezzature",
    noRoomsFound: "Nessuna sala trovata",
    adjustFilters: "Prova a modificare i filtri",
    roomFound: "sala trovata",
    roomsFound: "sale trovate",
    capacity: "Capacità",
    attendee: "partecipante",
    attendees: "partecipanti",
    tabsRooms: "Sale",
    tabsInsights: "Contesto",
    tabsShortlist: "Preferiti",
    meetingSummary: "Riepilogo riunione",
    insightsTitle: "Prepara la riunione",
    recommendedRooms: "Sale consigliate per questa fascia oraria",
    timeWindow: "Fascia oraria",
    noShortlist: "Avvia una ricerca per preparare una selezione",
    recommendedForYou: "Consigliato per te",
    refineSearch: "Affina la ricerca",
    people: "persone",
    allRooms: "Tutte le sale",
    loadingRooms: "Caricamento sale...",
    tryAdjustFilters: "Prova a modificare i filtri",
    noSubject: "Senza oggetto",
    organizer: "Organizzatore",
    you: "Tu",
    location: "Luogo",
    more: "altri",
    confirmed: "Confermata",
    changeRoom: "Cambia sala",
    cancelReservation: "Annulla prenotazione",
    loadingReservations: "Caricamento prenotazioni...",
    errorLoadingReservations: "Errore nel caricamento delle prenotazioni",
    currentMeetingReservation: "Prenotazione della riunione attuale",
    noReservations: "Nessuna prenotazione",
    noReservationsDescription: "Non hai nessuna sala prenotata per questa riunione",
    tabsBook: "Prenota",
    tabsReservations: "Le mie prenotazioni",
    cancel: "Annulla",
    allOfficesLabel: "Tutti gli uffici",
    office: "Ufficio",
    signOut: "Disconnetti",
    signIn: "Accedi",
    signedOutMessage: "Sei stato disconnesso.",
  },
  errorContext: {
    conflict: "Questa sala è già prenotata per questa fascia oraria. Prova un'altra sala.",
    network: "Controlla la tua connessione Internet e riprova. Se il problema persiste, prova a riconnetterti.",
    auth: "Effettua nuovamente l'accesso.",
    validation: "Verifica i tuoi dati e riprova.",
  },
};
